"use client";

import { useComboInstrumentsController } from "#/hooks/useComboInstruments.controller";
import { type OptionType } from "#/types/options";

export const useCovered = (optionType: OptionType) => {
  const {
    comboPerpInstruments,
    comboOptionInstruments,
    handleAddLegs,
    buildInstrument,
  } = useComboInstrumentsController();

  const perpSide = optionType === "call" ? "buy" : "sell";

  // 1 sell perp (for put) or 1 buy perp (for call) + 1 sell option (call or put)
  const applyCovered = () => {
    handleAddLegs([
      buildInstrument({
        type: "perps",
        side: perpSide,
      }),
      buildInstrument({
        type: "options",
        side: "sell",
        optionType,
      }),
    ]);
  };

  const isActivePatternCovered = () => {
    if (
      comboPerpInstruments.length !== 1 ||
      comboOptionInstruments.length !== 1
    )
      return false;

    const [perp] = comboPerpInstruments;
    const [option] = comboOptionInstruments;

    if (perp.side !== perpSide) return false;
    if (option.side !== "sell" || option.optionType !== optionType)
      return false;

    return true;
  };

  return { applyCovered, isActivePatternCovered };
};
